import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';
import { Fonts } from '../../../utils/resources/fonts';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export interface DragDropFileUploadCSSStyle extends UIComponentCSSStyle {
    getErrorMsgCSSStyle(): object;
    getInputCSSStyle(): object;
    getFileNameCSSStyle(): object;
    getButtonWrapperCSSStyle(): object;
    getButtonText(): object;
    getBrowseButtonStyle(): object;
    getUploadingTextCSSStyle(): object;
    getSuccessfullTextCSSStyle(): object;
    getDropFileTextCSSStyle(): object;
    getSupportMp3TextCSSStyle(): object;
    getSuccessFullIconCSSStyle(): object;
    getUploadIconCSSStyle(): object;
    getLoaderCSSStyle(): object;
    getPreviewPlayerWrapperCSSStyle(): object;
    getReplaceButtonCSSStyle(): object;
    getPreviewCSSStyle(): object;
}

export class DragDropFileUploadCSSStyleImpl extends UIComponentCSSStyleImpl implements DragDropFileUploadCSSStyle {

    getPreviewCSSStyle(): object {
       return {
            position: 'relative',
            //textAlign: "center",
            display: "inline-block",
            boxSizing: "border-box",
            cursor: 'pointer',
            width: "320px",
            borderRadius:'8px',
            height: "90px",
            // border: "1px dashed #D7006D",
            backgroundColor:this.getResources().getColor(Colors.color_36),
        };
    }

    getWrapperCSSStyle(): object {
        return {
            position: 'relative',
            //textAlign: "center",
            display: "inline-block",
            boxSizing: "border-box",
            cursor: 'pointer',
            width: this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ?"320px":'320px',
            height: "auto",
            borderRadius:'8px',

            // border: "1px dashed #D7006D",
            backgroundColor: this.getResources().getColor(Colors.color_37)
        };
    }

    getErrorMsgCSSStyle(): object {
        return {
            marginTop: '2px',
            color: this.getResources().getColor(Colors.color_11),
            width: '100%',
            fontSize: this.getResources().getFont(Fonts.h8),
            fontWeight: 600,
            fontFamily: this.getResources().getFontFamily()
        };
    }

    getFileNameCSSStyle(): object {
        return {
            position: "relative",
            float: "left",
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            color: this.getResources().getColor(Colors.color_5),
            width: '100%',
            fontSize: this.getResources().getFont(Fonts.h7),
            fontWeight: 600,
            fontFamily: this.getResources().getFontFamily()
        };
    }

    getInputCSSStyle(): object {
        return {
            position: 'relative',
            display: 'none',
        };
    }

    getButtonWrapperCSSStyle(): object {
        return {
            position: 'relative',
            height: '50px',
            width: '100%',
            cursor: "default",
        };
    }


    getBrowseButtonStyle(): object {
        return {
            color: this.getResources().getColor(Colors.color_38),
            fontSize: this.getResources().getFont(Fonts.h7),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            fontWeight: "900",
            letterSpacing: 0, 
            paddingLeft: "5px", 
            paddingRight: "5px",
            // textTransform: "uppercase",
            cursor: "pointer"

        };
    }
    getUploadingTextCSSStyle(): object {
        return {
            color: this.getResources().getColor(Colors.color_5), 
            fontSize: this.getResources().getFont(Fonts.h7), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            fontWeight: "300",
            letterSpacing: 0, 
            paddingTop: "7px",
            paddingLeft: "20px",
            paddingRight: "20px",
            // textTransform: "uppercase",
            cursor: "pointer"

        };
    }
    getSuccessfullTextCSSStyle(): object {
        return {
            color: this.getResources().getColor(Colors.color_38),
            fontSize: this.getResources().getFont(Fonts.h7),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            fontWeight: "900",
            letterSpacing: 0, 
            paddingTop: "7px",
            paddingLeft: "20px",
            paddingRight: "20px",
            // textTransform: "uppercase",
            cursor: "pointer"

        };
    }
    getDropFileTextCSSStyle(): object {
        return {
            color:this.getContext().getResources().getColor(Colors.color_5), 
            fontSize: this.getResources().getFont(Fonts.h7), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            fontWeight: "900",
            letterSpacing: 0, 
            float:"left",
            // textTransform: "uppercase",
            cursor: "pointer"
        };
    }
    getSupportMp3TextCSSStyle(): object {
        return {
            color: "#B6B6B6", 
            fontSize: this.getResources().getFont(Fonts.h5), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            fontWeight: "bold",
            letterSpacing: 0, 
            // textTransform: "uppercase",
            cursor: "pointer"

        };
    }

    getButtonText(): object {
        return {
            color: this.getResources().getColor(Colors.color_5),
            fontSize: this.getResources().getFont(Fonts.h8),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "50px",
            textAlign: "center",
            height: "50px",
            fontWeight: "bold",
            letterSpacing: 0,
            width: "120px",
            // textTransform: "uppercase",
            cursor: "pointer"
        };
    }

     getSuccessFullIconCSSStyle(): object
     {
        return {
            marginLeft: "5px",
            float: "left",
            height: "36px",
            width: "36px",
       };
     }

     getUploadIconCSSStyle(): object {
        return {
            marginLeft: "5px",
            float: "left",
            height: "31.5px",
            width: "31.5px",
            marginTop: "7px",
        };
    }

    getLoaderCSSStyle(): object {
        return {
            border: "2px solid " + "#EAEDF0",
            borderRadius: "50%",
            borderTop: "1px solid " + "#FFFFFF",
            width: "36px",
            height: "36px",
            animation: "spin 2s linear infinite"
        };
    }

    getPreviewPlayerWrapperCSSStyle(): object {
        return {
            display: "flex",
            flexWrap: "wrap",
            alignContent: "flex-start"
        };
    }

    getFilenameCSSStyle(): object {
        return {
            display: "flex",
            flexFlow: "row wrap",
            color: this.getResources().getColor(Colors.color_5),
            fontSize: this.getResources().getFont(Fonts.h7),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            height: "20px",
            width: "100%",
            fontWeight: 500,
            letterSpacing: 0,
            overflow : "hidden"
        };
    }

    getPlayerReplaceButtonDivCSSStyle(): object {
        return {
            display: "flex",
            flexFlow: "nowrap",
        };
    }
    getReplaceButtonCSSStyle(): object {
        return {
            height: "31px",
            width:'130px',
            float : "right",
            paddingRight: "0px",
            paddingLeft: "30px",
            paddingTop: "7px"
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dragdropfile/dragdropfileuploadcss.tsx